export enum StoreFlyerType {
    Poster = 'Poster',
    PosterV2 = 'PosterV2',
    InstagramVideo1 = 'InstagramVideo1',
    InstagramVideo2 = 'InstagramVideo2',
    InstagramVideo3 = 'InstagramVideo3',
    FacebookVideo1 = 'FacebookVideo1',
    FacebookVideo2 = 'FacebookVideo2',
    FacebookVideo3 = 'FacebookVideo3',
    Vippa = 'Vippa',
    SoMeVideo1 = 'SoMeVideo1',
    SoMeVideo2 = 'SoMeVideo2',
    SoMeImage1 = 'SoMeImage1',
    SoMeImage2 = 'SoMeImage2',
}

export type StoreFlyer = {
    id: string;
    type: StoreFlyerType;
    label: string;
    canBeOrdered: boolean;
}

export type StoreFlyersProps = {
    title: string;
    text?: any;
    body?: any;
    storeFlyers: StoreFlyer[];
    onSelectStoreFlyer: Function;
    onOrder: Function;
    loading: boolean;
    isLoggedIn: boolean | undefined;
}
